/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Menu, MenuItem, Popover } from '@material-ui/core';
import { MdSend, MdSearch, MdCancel, MdPictureAsPdf, MdSettings, MdCode } from 'react-icons/md';

import Paper from 'components/Paper';
import { LoadingPage } from 'components/Loading';
import Images from 'assets/img';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import Button from 'components/Button';
import { Row } from 'styles/components';
import Modal from './components/Modal';
import ModalImportarXml from './components/ModalImportarXml';
import ModalImportarMultiplosXml from './components/ModalImportarMultiplosXml';
import ModalEmitirCteLote from './components/ModalEmitirCteLote';
import ModalEventosCte from './components/ModalEventosCte';
import ModalParametrosSefaz from './components/ModalParametrosSefaz';
import ModalJustificativaCancelamento from './components/ModalJustificativaCancelamento';
import ActionsMenu from './components/ActionsMenu';
import MonitorMenu from './components/MonitorMenu';
import { Checkbox } from '@material-ui/core';
import TripActions from 'store/ducks/trip';
import { viagensAPI, cteAPI, sefazParamsAPI } from 'services/apiRest';
import { actions as toastrActions } from 'react-redux-toastr';

import {
  Container,
  WrapperTable,
} from './styles';

function Trip() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { viagens, isLoading } = useSelector((state) => state.trip);
  const [search, setSearch] = useState('');
  const [opened, setOpened] = useState(false);
  const [item, setItem] = useState(null);
  const [importarXmlOpen, setImportarXmlOpen] = useState(false);
  const [importarMultiplosXmlOpen, setImportarMultiplosXmlOpen] = useState(false);
  const [emitirCteLoteOpen, setEmitirCteLoteOpen] = useState(false);
  const [eventosCteOpen, setEventosCteOpen] = useState(false);
  const [viagemIdEventos, setViagemIdEventos] = useState(null);
  const [parametrosSefazOpen, setParametrosSefazOpen] = useState(false);
  const [outrasAcoesAnchorEl, setOutrasAcoesAnchorEl] = useState(null);
  const [viagensSelecionadas, setViagensSelecionadas] = useState([]); // Array de IDs das viagens selecionadas
  const [modalJustificativaOpen, setModalJustificativaOpen] = useState(false);
  const [deletePopoverAnchor, setDeletePopoverAnchor] = useState(null);
  const [viagemParaDeletar, setViagemParaDeletar] = useState(null);

  // Converter viagens para o formato da tabela (usando apenas viagens)
  const resolvedViagens = viagens.map((item, index) => ({
    actions: item.id,
    id: index,
    status: item.status || 'initial', // Usar status direto da tabela
    number: item.invoices?.length || 0,
    nfe_value: Number(item.value || item.freight_value || 0),
    taxes: 0, // Viagens podem não ter impostos separados
    emisson_tax: 0,
    transport_value: Number(item.freight_value || 0),
    due_date: item.validity ? new Date(item.validity).getTime() : (item.created_at ? new Date(item.created_at).getTime() : ''),
    total_value: Number(item.value || item.freight_value || 0),
    manifest_number: item.id,
    emission_date: item.created_at ? new Date(item.created_at).getTime() : '',
    invoices: item.invoices || [],
    // Manter dados originais da viagem
    viagemData: item,
  }));

  const filteredData = resolvedViagens.filter((item) =>
    String(item.manifest_number || '').toUpperCase().includes(search.toUpperCase())
  );

  function cancelPayment(id) {
    dispatch(TripActions.cancelPaymentRequest(id));
  }

  useEffect(() => {
    console.log('Trip component mounted');
    console.log('History object:', history);
    dispatch(TripActions.getViagensRequest());
  }, [dispatch, history]);
  
  // Recarregar lista quando voltar para a página
  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname === '/trip') {
        console.log('Página de viagens acessada, recarregando lista...');
        dispatch(TripActions.getViagensRequest());
      }
    });
    
    return () => unlisten();
  }, [history, dispatch]);

  if (isLoading) {
    return <LoadingPage />;
  }

  const handleDeleteViagem = (event, id) => {
    // Verificar se event existe e tem currentTarget
    if (event && event.currentTarget) {
      setDeletePopoverAnchor(event.currentTarget);
    } else {
      // Se event não existir, tentar encontrar o MenuItem que foi clicado
      // ou usar o elemento do Menu como fallback
      const menuItem = event?.target?.closest('[role="menuitem"]');
      if (menuItem) {
        setDeletePopoverAnchor(menuItem);
      } else {
        // Último recurso: criar elemento temporário posicionado onde o menu estava
        const tempElement = document.createElement('div');
        tempElement.style.position = 'fixed';
        tempElement.style.top = '50%';
        tempElement.style.left = '50%';
        tempElement.style.transform = 'translate(-50%, -50%)';
        document.body.appendChild(tempElement);
        setDeletePopoverAnchor(tempElement);
        
        // Remover elemento temporário quando o popover fechar
        setTimeout(() => {
          if (tempElement.parentNode) {
            tempElement.parentNode.removeChild(tempElement);
          }
        }, 100);
      }
    }
    setViagemParaDeletar(id);
  };

  const handleConfirmDelete = async () => {
    if (!viagemParaDeletar) return;
    try {
      // O saga removeViagem já dispara a mensagem de sucesso quando a exclusão for concluída
      await dispatch(TripActions.removeViagemRequest(viagemParaDeletar));
      // O saga também já recarrega a lista de viagens
    } catch (e) {
      console.error('[Trip] Erro ao deletar viagem:', e);
      // O saga já dispara a mensagem de erro em caso de falha
    } finally {
      // Remover elemento temporário se existir
      if (deletePopoverAnchor && deletePopoverAnchor.tagName === 'DIV' && deletePopoverAnchor.parentNode) {
        deletePopoverAnchor.parentNode.removeChild(deletePopoverAnchor);
      }
      setDeletePopoverAnchor(null);
      setViagemParaDeletar(null);
    }
  };

  const handleCancelDelete = () => {
    // Remover elemento temporário se existir
    if (deletePopoverAnchor && deletePopoverAnchor.tagName === 'DIV' && deletePopoverAnchor.parentNode) {
      deletePopoverAnchor.parentNode.removeChild(deletePopoverAnchor);
    }
    setDeletePopoverAnchor(null);
    setViagemParaDeletar(null);
  };

  /**
   * Remove valores undefined, null, objetos vazios e strings vazias para evitar problemas na serialização JSON
   */
  const limparDadosParaSerializacao = (obj, removerStringsVazias = false) => {
    if (obj === null || obj === undefined) {
      return undefined; // Retornar undefined para ser removido
    }
    
    if (Array.isArray(obj)) {
      const cleaned = obj.map(item => limparDadosParaSerializacao(item, removerStringsVazias))
        .filter(item => item !== null && item !== undefined);
      return cleaned.length > 0 ? cleaned : undefined;
    }
    
    if (typeof obj === 'object') {
      const cleaned = {};
      let hasValues = false;
      
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          
          // Ignorar valores undefined
          if (value === undefined) {
            continue;
          }
          
          // Processar recursivamente objetos e arrays
          const cleanedValue = limparDadosParaSerializacao(value, removerStringsVazias);
          
          // Verificar se o valor deve ser incluído
          if (cleanedValue !== null && cleanedValue !== undefined) {
            // Para strings vazias, só remover se a opção estiver ativada
            if (typeof cleanedValue === 'string' && cleanedValue === '' && removerStringsVazias) {
              continue;
            }
            
            // Para objetos, verificar se não está vazio
            if (typeof cleanedValue === 'object' && !Array.isArray(cleanedValue)) {
              if (Object.keys(cleanedValue).length > 0) {
                cleaned[key] = cleanedValue;
                hasValues = true;
              }
            } else {
              cleaned[key] = cleanedValue;
              hasValues = true;
            }
          }
        }
      }
      
      return hasValues ? cleaned : undefined;
    }
    
    // Para strings vazias, retornar string vazia (não remover por padrão)
    if (typeof obj === 'string' && obj === '' && removerStringsVazias) {
      return undefined;
    }
    
    return obj;
  };

  /**
   * Prepara dados da viagem para emissão de CT-e
   */
  const prepararDadosCte = async (viagemId) => {
    try {
      // Buscar dados completos da viagem
      const viagem = await viagensAPI.buscarPorId(viagemId);
      
      if (!viagem) {
        throw new Error('Viagem não encontrada');
      }

      // Converter dados da viagem para o formato esperado pela API de CT-e
      const dadosCte = {
        // Dados básicos do CT-e
        viagem_id: viagem.id, // ID da viagem para relacionar com eventos
        ambiente: viagem.ambiente || '2', // 1=Produção, 2=Homologação
        referencia: viagem.id,
        data_emissao: viagem.data_emissao || new Date().toISOString().split('T')[0], // YYYY-MM-DD
        
        // Emitente
        emitente: viagem.emitente ? {
          cpf_cnpj: viagem.emitente.cpf_cnpj || '',
          nome_razao_social: viagem.emitente.nome_razao_social || '',
          inscricao_estadual: viagem.emitente.inscricao_estadual || '',
          inscricao_municipal: viagem.emitente.inscricao_municipal || '',
          email: viagem.emitente.email || '',
          endereco: viagem.emitente.endereco || {},
          telefones: viagem.emitente.telefones || [],
        } : null,
        
        // RNTRC (Registro Nacional de Transportador de Carga) - obrigatório para CT-e
        rntrc: viagem.rntrc || viagem.emitente?.rntrc || '',
        
        // Remetente
        remetente: viagem.remetente ? {
          cpf_cnpj: viagem.remetente.cpf_cnpj || '',
          nome_razao_social: viagem.remetente.nome_razao_social || '',
          inscricao_estadual: viagem.remetente.inscricao_estadual || '',
          email: viagem.remetente.email || '',
          endereco: viagem.remetente.endereco || {},
          telefones: viagem.remetente.telefones || [],
        } : null,
        
        // Destinatário
        destinatario: viagem.destinatario ? {
          cpf_cnpj: viagem.destinatario.cpf_cnpj || '',
          nome_razao_social: viagem.destinatario.nome_razao_social || '',
          inscricao_estadual: viagem.destinatario.inscricao_estadual || '',
          email: viagem.destinatario.email || '',
          endereco: viagem.destinatario.endereco || {},
          telefones: viagem.destinatario.telefones || [],
        } : null,
        
        // Tomador
        tomador: viagem.tomador ? {
          tipo: viagem.tomador.tipo || '0',
          cpf_cnpj: viagem.tomador.cpf_cnpj || '',
          nome_razao_social: viagem.tomador.nome_razao_social || '',
          inscricao_estadual: viagem.tomador.inscricao_estadual || '',
          email: viagem.tomador.email || '',
          endereco: viagem.tomador.endereco || {},
          telefones: viagem.tomador.telefones || [],
        } : null,
        
        // Transporte
        transporte: {
          modal: viagem.modal || '01', // 01=Rodoviário
          tipo_servico: viagem.tipo_servico || '0', // 0=Normal
          natureza_operacao: viagem.natureza_operacao || '',
          cfop: viagem.cfop || '',
        },
        
        // Municípios de carregamento e descarregamento (para cMunIni/cMunFim)
        codigo_municipio_carregamento: viagem.codigo_municipio_carregamento || '',
        nome_municipio_carregamento: viagem.nome_municipio_carregamento || '',
        uf_carregamento: viagem.uf_carregamento || viagem.uf_inicio || '',
        codigo_municipio_descarregamento: viagem.codigo_municipio_descarregamento || '',
        nome_municipio_descarregamento: viagem.nome_municipio_descarregamento || '',
        uf_descarregamento: viagem.uf_descarregamento || viagem.uf_fim || '',
        
        // Valores
        valor_servico: viagem.valor_servico || '0.00',
        valor_receber: viagem.valor_receber || '0.00',
        valor_carga: viagem.valor_carga || '0.00',
        
        // Veículo
        veiculo: (viagem.veiculo || viagem.veiculo_placa) ? {
          placa: viagem.veiculo?.placa || viagem.veiculo_placa || '',
          renavam: viagem.veiculo?.renavam || viagem.veiculo_renavam || '',
          uf: viagem.veiculo?.uf || viagem.veiculo_uf || '',
          proprietario: (viagem.veiculo?.proprietario || viagem.veiculo_proprietario) ? {
            cpf_cnpj: viagem.veiculo?.proprietario?.cpf_cnpj || viagem.veiculo_proprietario?.cpf_cnpj || '',
            nome: viagem.veiculo?.proprietario?.nome || viagem.veiculo_proprietario?.nome || '',
            inscricao_estadual: viagem.veiculo?.proprietario?.inscricao_estadual || viagem.veiculo_proprietario?.inscricao_estadual || '',
            uf: viagem.veiculo?.proprietario?.uf || viagem.veiculo_proprietario?.uf || '',
          } : null,
        } : null,
        
        // Motorista
        motorista: viagem.motorista ? {
          nome: viagem.motorista.nome || '',
          cpf: viagem.motorista.cpf || '',
          telefones: viagem.motorista.telefones || [],
        } : null,
        
        // Volumes
        volumes: viagem.volumes || [],
        
        // Chave NFe (obrigatória para CT-e)
        chave_nfe: viagem.chave_nfe || '',
        
        // Informações adicionais
        informacoes_complementares: viagem.informacoes_complementares || '',
        observacoes: viagem.observacoes || '',
      };

      console.log('📦 Dados do CT-e preparados (antes da limpeza):', JSON.stringify(dadosCte, null, 2));

      // Limpar dados para evitar problemas na serialização JSON
      // Remover undefined, null e objetos vazios, mas manter strings vazias (alguns campos podem ser opcionais)
      const dadosCteLimpos = limparDadosParaSerializacao(dadosCte, false);
      
      // Verificar se a serialização funciona
      try {
        const testSerialization = JSON.stringify(dadosCteLimpos);
        console.log('✅ Serialização JSON bem-sucedida. Tamanho:', testSerialization.length, 'caracteres');
      } catch (error) {
        console.error('❌ Erro na serialização JSON:', error);
        throw new Error(`Erro ao serializar dados do CT-e: ${error.message}`);
      }
      
      console.log('📦 Dados do CT-e preparados (após limpeza):', JSON.stringify(dadosCteLimpos, null, 2));

      return dadosCteLimpos;
    } catch (error) {
      console.error('Erro ao preparar dados do CT-e:', error);
      throw new Error(`Erro ao buscar dados da viagem: ${error.message}`);
    }
  };

  /**
   * Emite CT-e para uma viagem individual
   */
  const emitirCteIndividual = async (viagemId) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Preparando emissão do CT-e...',
        })
      );

      const dadosCte = await prepararDadosCte(viagemId);
      const resultado = await cteAPI.emitir(dadosCte);

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'CT-e transmitido com sucesso!',
        })
      );

      // Recarregar lista de viagens
      dispatch(TripActions.getViagensRequest());

      return resultado;
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao emitir CT-e',
          message: error.message || 'Erro desconhecido',
        })
      );
      throw error;
    }
  };

  /**
   * Emite CT-e para um range de viagens
   */
  const emitirCteLote = async (idDe, idAte) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: `Emitindo CT-e para viagens de ${idDe} até ${idAte}...`,
        })
      );

      const resultados = [];
      const erros = [];

      for (let id = idDe; id <= idAte; id++) {
        try {
          const resultado = await emitirCteIndividual(id);
          resultados.push({ id, sucesso: true, resultado });
        } catch (error) {
          erros.push({ id, sucesso: false, erro: error.message });
        }
      }

      dispatch(
        toastrActions.add({
          type: resultados.length > erros.length ? 'success' : 'warning',
          title: 'Emissão concluída',
          message: `${resultados.length} CT-e(s) emitido(s) com sucesso. ${erros.length} erro(s).`,
        })
      );

      // Recarregar lista de viagens
      dispatch(TripActions.getViagensRequest());

      return { resultados, erros };
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao emitir CT-e em lote',
          message: error.message || 'Erro desconhecido',
        })
      );
      throw error;
    }
  };

  const handleEmitir = async (item) => {
    try {
      const viagemId = item.manifest_number || item.id;
      if (!viagemId) {
        dispatch(
          toastrActions.add({
            type: 'error',
            title: 'Erro',
            message: 'ID da viagem não encontrado',
          })
        );
        return;
      }

      await emitirCteIndividual(viagemId);
    } catch (error) {
      // Erro já tratado na função emitirCteIndividual
    }
  };

  const handleSincronizar = async (item) => {
    try {
      const viagemId = item.manifest_number || item.id;
      
      if (!viagemId) {
        dispatch(
          toastrActions.add({
            type: 'error',
            title: 'Erro',
            message: 'ID da viagem não encontrado',
          })
        );
        return;
      }

      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Sincronizando',
          message: 'Sincronizando CT-e com a SEFAZ...',
        })
      );

      // Buscar último evento da viagem para obter o cte_id
      const ultimoEvento = await cteAPI.buscarUltimoEvento(viagemId);
      
      if (ultimoEvento && ultimoEvento.cte_id) {
        // Sincronizar usando POST /cte/:id/sincronizar
        await cteAPI.sincronizarCte(ultimoEvento.cte_id);
        
        dispatch(
          toastrActions.add({
            type: 'success',
            title: 'Sucesso',
            message: 'CT-e sincronizado com sucesso!',
          })
        );
        
        // Recarregar lista de viagens para atualizar status
        dispatch(TripActions.getViagensRequest());
      } else {
        // Se não tiver evento, tentar consultar diretamente se houver algum identificador
        // Ou informar que não há CT-e para sincronizar
        dispatch(
          toastrActions.add({
            type: 'warning',
            title: 'Aviso',
            message: 'Nenhum CT-e encontrado para esta viagem. Emita o CT-e primeiro.',
          })
        );
      }
    } catch (error) {
      console.error('Erro ao sincronizar CT-e:', error);
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: error.message || 'Erro ao sincronizar CT-e. Tente novamente.',
        })
      );
    }
  };

  /**
   * Cancelar CT-e de uma viagem individual
   */
  const handleCancelar = async (item) => {
    try {
      // Abrir modal de justificativa
      setItem(item);
      setModalJustificativaOpen(true);
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: error.message || 'Erro ao abrir modal de cancelamento',
        })
      );
    }
  };


  /**
   * Baixar XML de uma viagem individual
   */
  const handleBaixarXml = async (item) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Baixando XML...',
        })
      );

      // Buscar último evento de CT-e da viagem
      const viagemId = item.manifest_number || item.id;
      const ultimoEvento = await cteAPI.buscarUltimoEvento(viagemId);
      
      if (!ultimoEvento || !ultimoEvento.cte_id) {
        dispatch(
          toastrActions.add({
            type: 'error',
            title: 'Erro',
            message: 'Nenhum CT-e encontrado para esta viagem',
          })
        );
        return;
      }

      const cteId = ultimoEvento.cte_id;

      // Baixar XML
      const blob = await cteAPI.baixarXmlConhecimento(cteId);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `cte-${cteId}-${viagemId}-conhecimento.xml`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'XML baixado com sucesso!',
        })
      );
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao baixar XML',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };

  /**
   * Baixar PDF de uma viagem individual
   */
  const handleBaixarPdf = async (item) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: 'Baixando PDF...',
        })
      );

      // Buscar último evento de CT-e da viagem
      const viagemId = item.manifest_number || item.id;
      const ultimoEvento = await cteAPI.buscarUltimoEvento(viagemId);
      
      if (!ultimoEvento || !ultimoEvento.cte_id) {
        dispatch(
          toastrActions.add({
            type: 'error',
            title: 'Erro',
            message: 'Nenhum CT-e encontrado para esta viagem',
          })
        );
        return;
      }

      const cteId = ultimoEvento.cte_id;

      // Baixar PDF
      const blob = await cteAPI.baixarPdf(cteId);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `cte-${cteId}-${viagemId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'PDF baixado com sucesso!',
        })
      );
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao baixar PDF',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };

  const handleOutrasAcoesOpen = (event) => {
    setOutrasAcoesAnchorEl(event.currentTarget);
  };

  const handleOutrasAcoesClose = () => {
    setOutrasAcoesAnchorEl(null);
  };

  /**
   * Funções para gerenciar seleção de viagens
   */
  const handleToggleViagem = (viagemId) => {
    setViagensSelecionadas(prev => {
      if (prev.includes(viagemId)) {
        return prev.filter(id => id !== viagemId);
      } else {
        return [...prev, viagemId];
      }
    });
  };

  const handleSelecionarTodas = () => {
    if (viagensSelecionadas.length === filteredData.length) {
      setViagensSelecionadas([]);
    } else {
      setViagensSelecionadas(filteredData.map(v => v.id));
    }
  };

  /**
   * Emitir CT-e para viagens selecionadas
   */
  const handleEmitirCte = async () => {
    handleOutrasAcoesClose();
    
    if (viagensSelecionadas.length === 0) {
      dispatch(
        toastrActions.add({
          type: 'warning',
          title: 'Atenção',
          message: 'Selecione pelo menos uma viagem para emitir CT-e',
        })
      );
      return;
    }

    await handleEmitirCteLoteSelecao(viagensSelecionadas);
    setViagensSelecionadas([]);
  };

  const handleConfirmarEmitirCteLote = async (idDe, idAte) => {
    try {
      await emitirCteLote(idDe, idAte);
      setEmitirCteLoteOpen(false);
    } catch (error) {
      // Erro já tratado na função emitirCteLote
    }
  };

  /**
   * Consultar status da SEFAZ
   * Não requer parâmetros - apenas verifica se o serviço está funcionando
   */
  const handleStatusSefaz = async () => {
    try {
      handleOutrasAcoesClose();
      
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Consultando',
          message: 'Consultando status do serviço da SEFAZ...',
        })
      );

      // Consulta não requer parâmetros
      const resultado = await cteAPI.consultarStatusSefaz();
      
      // Formatar mensagem com layout específico
      const linhasMensagem = [];
      
      // Título: motivo_status em maiúsculas ou "SERVICO EM OPERACAO"
      const titulo = resultado.motivo_status 
        ? resultado.motivo_status.toUpperCase()
        : 'SERVICO EM OPERACAO';
      linhasMensagem.push(titulo);
      linhasMensagem.push(''); // Linha em branco
      
      if (resultado.autorizador) {
        linhasMensagem.push(`Autorizador: ${resultado.autorizador}`);
      }
      
      if (resultado.ambiente) {
        linhasMensagem.push(`Ambiente: ${resultado.ambiente}`);
      }
      
      if (resultado.codigo_status !== undefined && resultado.codigo_status !== null) {
        linhasMensagem.push(`Status: ${resultado.codigo_status}`);
      }
      
      if (resultado.motivo_status) {
        linhasMensagem.push(`Motivo: ${resultado.motivo_status}`);
      }
      
      if (resultado.tempo_medio_resposta !== undefined && resultado.tempo_medio_resposta !== null) {
        linhasMensagem.push(`Tempo médio: ${resultado.tempo_medio_resposta}ms`);
      }
      
      const mensagem = linhasMensagem.length > 0 
        ? linhasMensagem.join('\n')
        : 'Status consultado com sucesso';
      
      dispatch(
        toastrActions.add({
          type: resultado.codigo_status > 0 ? 'success' : 'warning',
          title: 'Status SEFAZ',
          message: mensagem,
          options: {
            duration: 30000,
            showCloseButton: true,
          }
        })
      );

      console.log('Status SEFAZ:', resultado);
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao consultar status SEFAZ',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };

  /**
   * Cancelar CT-e para viagens selecionadas
   */
  const handleCancelarCte = () => {
    handleOutrasAcoesClose();
    
    if (viagensSelecionadas.length === 0) {
      dispatch(
        toastrActions.add({
          type: 'warning',
          title: 'Atenção',
          message: 'Selecione pelo menos uma viagem para cancelar CT-e',
        })
      );
      return;
    }

    setModalJustificativaOpen(true);
  };

  /**
   * Confirmar cancelamento com justificativa
   * Funciona tanto para viagem individual quanto para lote
   */
  const handleConfirmarCancelamento = async (justificativa) => {
    // Se há um item individual selecionado, cancelar apenas esse
    if (item) {
      try {
        if (!justificativa || justificativa.trim() === '') {
          dispatch(
            toastrActions.add({
              type: 'error',
              title: 'Erro',
              message: 'Justificativa é obrigatória',
            })
          );
          return;
        }

        dispatch(
          toastrActions.add({
            type: 'info',
            title: 'Processando',
            message: 'Cancelando CT-e...',
          })
        );

        // Buscar último evento de CT-e da viagem
        const viagemId = item.manifest_number || item.id;
        const ultimoEvento = await cteAPI.buscarUltimoEvento(viagemId);
        
        if (!ultimoEvento || !ultimoEvento.cte_id) {
          dispatch(
            toastrActions.add({
              type: 'error',
              title: 'Erro',
              message: 'Nenhum CT-e encontrado para esta viagem',
            })
          );
          return;
        }

        await cteAPI.cancelarCte(ultimoEvento.cte_id, justificativa.trim());

        dispatch(
          toastrActions.add({
            type: 'success',
            title: 'Sucesso',
            message: 'CT-e cancelado com sucesso!',
          })
        );

        // Fechar modal e limpar item
        setModalJustificativaOpen(false);
        setItem(null);

        // Recarregar lista de viagens
        dispatch(TripActions.getViagensRequest());
      } catch (error) {
        dispatch(
          toastrActions.add({
            type: 'error',
            title: 'Erro ao cancelar CT-e',
            message: error.message || 'Erro desconhecido',
          })
        );
      }
    } else {
      // Cancelar em lote
      await handleCancelarCteLote(viagensSelecionadas, justificativa);
      setViagensSelecionadas([]);
    }
  };

  /**
   * Cancelar CT-e em lote
   */
  const handleCancelarCteLote = async (viagemIds, justificativa) => {
    try {
      if (!justificativa || justificativa.trim() === '') {
        dispatch(
          toastrActions.add({
            type: 'error',
            title: 'Erro',
            message: 'Justificativa é obrigatória',
          })
        );
        return;
      }

      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: `Cancelando ${viagemIds.length} CT-e(s)...`,
        })
      );

      const resultados = {
        sucesso: [],
        erro: [],
      };

      // Processar cada viagem
      for (const viagemId of viagemIds) {
        try {
          const viagem = resolvedViagens.find(v => v.id === viagemId);
          if (!viagem || !viagem.viagemData) {
            resultados.erro.push({ id: viagemId, motivo: 'Viagem não encontrada' });
            continue;
          }

          // Buscar último evento de CT-e da viagem
          const ultimoEvento = await cteAPI.buscarUltimoEvento(viagem.viagemData.id);
          if (!ultimoEvento || !ultimoEvento.cte_id) {
            resultados.erro.push({ id: viagemId, motivo: 'Nenhum CT-e encontrado' });
            continue;
          }

          await cteAPI.cancelarCte(ultimoEvento.cte_id, justificativa.trim());
          resultados.sucesso.push(viagemId);
        } catch (error) {
          resultados.erro.push({ id: viagemId, motivo: error.message || 'Erro desconhecido' });
        }
      }

      // Mostrar resultados
      if (resultados.sucesso.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'success',
            title: 'Sucesso',
            message: `${resultados.sucesso.length} CT-e(s) cancelado(s) com sucesso!`,
          })
        );
      }

      if (resultados.erro.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'warning',
            title: 'Atenção',
            message: `${resultados.erro.length} CT-e(s) não puderam ser cancelado(s). Verifique os detalhes.`,
          })
        );
      }

      // Recarregar lista de viagens
      dispatch(TripActions.getViagensRequest());
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao cancelar CT-e em lote',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };

  /**
   * Baixar PDFs para viagens selecionadas
   */
  const handleBaixarPdfs = async () => {
    handleOutrasAcoesClose();
    
    if (viagensSelecionadas.length === 0) {
      dispatch(
        toastrActions.add({
          type: 'warning',
          title: 'Atenção',
          message: 'Selecione pelo menos uma viagem para baixar PDFs',
        })
      );
      return;
    }

    await handleBaixarPdfsLote(viagensSelecionadas);
    setViagensSelecionadas([]);
  };

  /**
   * Baixar XMLs para viagens selecionadas
   */
  const handleBaixarXmls = async () => {
    handleOutrasAcoesClose();
    
    if (viagensSelecionadas.length === 0) {
      dispatch(
        toastrActions.add({
          type: 'warning',
          title: 'Atenção',
          message: 'Selecione pelo menos uma viagem para baixar XMLs',
        })
      );
      return;
    }

    await handleBaixarXmlsLote(viagensSelecionadas);
    setViagensSelecionadas([]);
  };

  /**
   * Baixar PDFs em lote
   */
  const handleBaixarPdfsLote = async (viagemIds) => {
    try {
      const tipoArquivo = 'PDF';
      const nomeArquivo = 'pdf';

      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: `Baixando ${tipoArquivo} de ${viagemIds.length} CT-e(s)...`,
        })
      );

      const resultados = {
        sucesso: [],
        erro: [],
      };

      // Processar cada viagem
      for (const viagemId of viagemIds) {
        try {
          const viagem = resolvedViagens.find(v => v.id === viagemId);
          if (!viagem || !viagem.viagemData) {
            resultados.erro.push({ id: viagemId, motivo: 'Viagem não encontrada' });
            continue;
          }

          // Buscar último evento de CT-e da viagem
          const ultimoEvento = await cteAPI.buscarUltimoEvento(viagem.viagemData.id);
          if (!ultimoEvento || !ultimoEvento.cte_id) {
            resultados.erro.push({ id: viagemId, motivo: 'Nenhum CT-e encontrado' });
            continue;
          }

          const cteId = ultimoEvento.cte_id;

          // Baixar PDF
          const blob = await cteAPI.baixarPdf(cteId);

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `cte-${cteId}-${viagem.viagemData.id || viagemId}.${nomeArquivo}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // Pequeno delay entre downloads para evitar sobrecarga
          await new Promise(resolve => setTimeout(resolve, 500));

          resultados.sucesso.push(viagemId);
        } catch (error) {
          resultados.erro.push({ id: viagemId, motivo: error.message || 'Erro desconhecido' });
        }
      }

      // Mostrar resultados
      if (resultados.sucesso.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'success',
            title: 'Sucesso',
            message: `${resultados.sucesso.length} ${tipoArquivo}(s) baixado(s) com sucesso!`,
          })
        );
      }

      if (resultados.erro.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'warning',
            title: 'Atenção',
            message: `${resultados.erro.length} ${tipoArquivo}(s) não puderam ser baixado(s). Verifique os detalhes.`,
          })
        );
      }
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao baixar documentos em lote',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };

  /**
   * Baixar XMLs em lote
   */
  const handleBaixarXmlsLote = async (viagemIds) => {
    try {
      const tipoArquivo = 'XML';
      const nomeArquivo = 'xml';

      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: `Baixando ${tipoArquivo} de ${viagemIds.length} CT-e(s)...`,
        })
      );

      const resultados = {
        sucesso: [],
        erro: [],
      };

      // Processar cada viagem
      for (const viagemId of viagemIds) {
        try {
          const viagem = resolvedViagens.find(v => v.id === viagemId);
          if (!viagem || !viagem.viagemData) {
            resultados.erro.push({ id: viagemId, motivo: 'Viagem não encontrada' });
            continue;
          }

          // Buscar último evento de CT-e da viagem
          const ultimoEvento = await cteAPI.buscarUltimoEvento(viagem.viagemData.id);
          if (!ultimoEvento || !ultimoEvento.cte_id) {
            resultados.erro.push({ id: viagemId, motivo: 'Nenhum CT-e encontrado' });
            continue;
          }

          const cteId = ultimoEvento.cte_id;

          // Baixar XML
          const blob = await cteAPI.baixarXmlConhecimento(cteId);

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `cte-${cteId}-${viagem.viagemData.id || viagemId}-conhecimento.${nomeArquivo}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // Pequeno delay entre downloads para evitar sobrecarga
          await new Promise(resolve => setTimeout(resolve, 500));

          resultados.sucesso.push(viagemId);
        } catch (error) {
          resultados.erro.push({ id: viagemId, motivo: error.message || 'Erro desconhecido' });
        }
      }

      // Mostrar resultados
      if (resultados.sucesso.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'success',
            title: 'Sucesso',
            message: `${resultados.sucesso.length} ${tipoArquivo}(s) baixado(s) com sucesso!`,
          })
        );
      }

      if (resultados.erro.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'warning',
            title: 'Atenção',
            message: `${resultados.erro.length} ${tipoArquivo}(s) não puderam ser baixado(s). Verifique os detalhes.`,
          })
        );
      }
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao baixar documentos em lote',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };

  /**
   * Emitir CT-e em lote (usando seleção múltipla)
   */
  const handleEmitirCteLoteSelecao = async (viagemIds) => {
    try {
      dispatch(
        toastrActions.add({
          type: 'info',
          title: 'Processando',
          message: `Emitindo ${viagemIds.length} CT-e(s)...`,
        })
      );

      const resultados = {
        sucesso: [],
        erro: [],
      };

      // Processar cada viagem
      for (const viagemId of viagemIds) {
        try {
          const viagem = resolvedViagens.find(v => v.id === viagemId);
          if (!viagem || !viagem.viagemData) {
            resultados.erro.push({ id: viagemId, motivo: 'Viagem não encontrada' });
            continue;
          }

          await emitirCteIndividual(viagem.viagemData.id);
          resultados.sucesso.push(viagemId);
        } catch (error) {
          resultados.erro.push({ id: viagemId, motivo: error.message || 'Erro desconhecido' });
        }
      }

      // Mostrar resultados
      if (resultados.sucesso.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'success',
            title: 'Sucesso',
            message: `${resultados.sucesso.length} CT-e(s) emitido(s) com sucesso!`,
          })
        );
      }

      if (resultados.erro.length > 0) {
        dispatch(
          toastrActions.add({
            type: 'warning',
            title: 'Atenção',
            message: `${resultados.erro.length} CT-e(s) não puderam ser emitido(s). Verifique os detalhes.`,
          })
        );
      }

      // Recarregar lista de viagens
      dispatch(TripActions.getViagensRequest());
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao emitir CT-e em lote',
          message: error.message || 'Erro desconhecido',
        })
      );
    }
  };


  return (
    <Container>
      <Paper
        title="Viagem"
        icon={Images.IconPaper}
        rightContent={
          <Row style={{ gap: '10px', alignItems: 'center', justifyContent: 'flex-end' }}>
            <div style={{ minWidth: '200px', maxWidth: '350px' }}>
              <SearchInput
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => setSearch('')}
                value={search}
              />
            </div>
            <div
              onClick={(e) => {
                console.log('Div wrapper clicked');
                e.stopPropagation();
              }}
              onMouseDown={(e) => {
                console.log('Div wrapper mouse down');
              }}
            >
              <button
                type="button"
                onClick={(e) => {
                  console.log('=== BOTÃO CLICADO ===');
                  console.log('Event:', e);
                  console.log('History:', history);
                  e.preventDefault();
                  e.stopPropagation();
                  try {
                    console.log('Tentando navegar para /trip/create');
                    history.push('/trip/create');
                    console.log('Navegação executada com sucesso');
                  } catch (error) {
                    console.error('Erro na navegação:', error);
                    window.location.href = '/trip/create';
                  }
                }}
                onMouseDown={(e) => {
                  console.log('Mouse down no botão HTML');
                }}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#4caf50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Nova Viagem
              </button>
            </div>
            <button
              type="button"
              onClick={() => {
                console.log('Botão Importar Múltiplos XMLs clicado');
                setImportarMultiplosXmlOpen(true);
              }}
              style={{
                padding: '8px 16px',
                backgroundColor: '#FFF28D',
                color: '#122d58',
                border: 'none',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                boxShadow: '0px 3px 6px #00000029',
              }}
            >
              Importar Múltiplos XMLs
            </button>
            <button
              type="button"
              onClick={handleOutrasAcoesOpen}
              style={{
                padding: '8px 16px',
                backgroundColor: '#ebebe',
                color: '#122d58',
                border: 'none',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                boxShadow: '0px 3px 6px #00000029',
                marginLeft: '10px',
              }}
            >
              Outras Ações
            </button>
            <Menu
              anchorEl={outrasAcoesAnchorEl}
              open={Boolean(outrasAcoesAnchorEl)}
              onClose={handleOutrasAcoesClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem
                onClick={handleEmitirCte}
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <MdSend size={18} style={{ color: '#4caf50' }} />
                Emitir CT-e
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setParametrosSefazOpen(true);
                  handleOutrasAcoesClose();
                }}
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <MdSettings size={18} style={{ color: '#9c27b0' }} />
                Parâmetros SEFAZ
              </MenuItem>
              <MenuItem
                onClick={handleStatusSefaz}
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <MdSearch size={18} style={{ color: '#2196F3' }} />
                Status Sefaz
              </MenuItem>
              <MenuItem
                onClick={handleCancelarCte}
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <MdCancel size={18} style={{ color: '#f27160' }} />
                Cancelar CT-e
              </MenuItem>
              <MenuItem
                onClick={handleBaixarPdfs}
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <MdPictureAsPdf size={18} style={{ color: '#f44336' }} />
                Baixar PDFs
              </MenuItem>
              <MenuItem
                onClick={handleBaixarXmls}
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <MdCode size={18} style={{ color: '#ff9800' }} />
                Baixar XMLs
              </MenuItem>
            </Menu>
          </Row>
        }
      >
        <WrapperTable>
          
          <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Checkbox
              checked={viagensSelecionadas.length > 0 && viagensSelecionadas.length === filteredData.length}
              indeterminate={viagensSelecionadas.length > 0 && viagensSelecionadas.length < filteredData.length}
              onChange={handleSelecionarTodas}
              color="primary"
            />
            <span style={{ fontSize: '14px', color: '#666' }}>
              {viagensSelecionadas.length > 0 
                ? `${viagensSelecionadas.length} viagem(ns) selecionada(s)`
                : 'Selecione as viagens para realizar ações em lote'}
            </span>
          </div>
          <Table
            columns={[
              { label: '', id: 'select' },
              { label: 'Ações', id: 'actions' },
              { label: 'ID', id: 'id' },
              { label: 'Status', id: 'status' },
              { label: 'Nº de Notas', id: 'number' },
              { label: "Valor das NFe's", id: 'nfe_value' },
              { label: 'Impostos', id: 'taxes' },
              { label: 'Tx de Emissão', id: 'emisson_tax' },
              { label: 'Valor do Frete', id: 'transport_value' },
              { label: 'Vencimento', id: 'due_date' },
              { label: 'Valor total', id: 'total_value' },
              { label: 'Número do manifesto', id: 'manifest_number' },
              { label: 'Data de emissão', id: 'emission_date' },
            ]}
            data={filteredData}
            customComponent={{
              select: (e, item) => (
                <Checkbox
                  checked={viagensSelecionadas.includes(item.id)}
                  onChange={() => handleToggleViagem(item.id)}
                  color="primary"
                />
              ),
              actions: (e, item) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <ActionsMenu
                    item={item}
                    onView={(item) => {
                      setOpened(true);
                      setItem(item);
                    }}
                    onEdit={(item) => {
                      history.push(`/trip/edit/${item.manifest_number}`);
                    }}
                    onDelete={(item, event) => {
                      handleDeleteViagem(event, item.manifest_number);
                    }}
                    onWhatsapp={(item) => {
                      // Implementar ação do WhatsApp
                    }}
                    onBlock={(item) => {
                      cancelPayment(item.manifest_number);
                    }}
                  />
                  <MonitorMenu
                    item={item}
                    onEmitir={handleEmitir}
                    onSincronizar={handleSincronizar}
                    onCancelar={handleCancelar}
                    onBaixarXml={handleBaixarXml}
                    onBaixarPdf={handleBaixarPdf}
                    onVerEventos={(item) => {
                      setViagemIdEventos(item.manifest_number || item.id);
                      setEventosCteOpen(true);
                    }}
                  />
                </div>
              ),

              status: (e) => {
                // Usar status direto da tabela viagens
                // Valores possíveis: 'initial', 'Enviado', 'Transmitido', 'Autorizado', 'Rejeitado', 'Cancelado', etc.
                if (!e || e === 'initial') return 'Pendente';
                // Retornar o status exatamente como está na tabela
                return e;
              },
              nfe_value: (e) =>
                e.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }),
              taxes: (e) =>
                e.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }),
              emisson_tax: (e) =>
                e.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }),
              transport_value: (e) =>
                e.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }),
              due_date: (e) => (e ? format(new Date(e), 'dd/MM/yyyy') : '-'),
              total_value: (e) =>
                e.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }),
              emission_date: (e) =>
                e ? format(new Date(e), 'dd/MM/yyyy') : '-',
            }}
          />
        </WrapperTable>
      </Paper>
      <Modal open={opened} onClose={() => setOpened(false)} data={item} />
      <ModalImportarXml
        open={importarXmlOpen}
        onClose={() => setImportarXmlOpen(false)}
        onSuccess={(resultado) => {
          // Recarregar lista de viagens após importação
          dispatch(TripActions.getViagensRequest());
          setImportarXmlOpen(false);
        }}
      />
      <ModalImportarMultiplosXml
        open={importarMultiplosXmlOpen}
        onClose={() => setImportarMultiplosXmlOpen(false)}
        onSuccess={(resultado) => {
          // Recarregar lista de viagens após importação
          dispatch(TripActions.getViagensRequest());
          setImportarMultiplosXmlOpen(false);
        }}
      />
      <ModalEmitirCteLote
        open={emitirCteLoteOpen}
        onClose={() => setEmitirCteLoteOpen(false)}
        onConfirm={handleConfirmarEmitirCteLote}
      />
      <ModalEventosCte
        open={eventosCteOpen}
        onClose={() => {
          setEventosCteOpen(false);
          setViagemIdEventos(null);
        }}
        viagemId={viagemIdEventos}
      />
      <ModalParametrosSefaz
        open={parametrosSefazOpen}
        onClose={() => setParametrosSefazOpen(false)}
      />
      <ModalJustificativaCancelamento
        open={modalJustificativaOpen}
        onClose={() => {
          setModalJustificativaOpen(false);
          setItem(null);
        }}
        onConfirm={handleConfirmarCancelamento}
        quantidadeViagens={item ? 1 : viagensSelecionadas.length}
      />
      <Popover
        open={Boolean(deletePopoverAnchor)}
        anchorEl={deletePopoverAnchor}
        onClose={handleCancelDelete}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <p style={{ fontSize: '14px', fontWeight: 600, color: '#7b7b7b', marginBottom: '15px' }}>
            Tem certeza que deseja excluir?
          </p>
          <Row>
            <button
              onClick={handleConfirmDelete}
              style={{
                backgroundColor: '#122d58',
                color: '#fff',
                border: '1px solid #122d58',
                borderRadius: '5px',
                padding: '8px 20px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                margin: '0 5px',
              }}
            >
              Sim
            </button>
            <button
              onClick={handleCancelDelete}
              style={{
                backgroundColor: '#fff',
                color: '#122d58',
                border: '1px solid #122d58',
                borderRadius: '5px',
                padding: '8px 20px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                margin: '0 5px',
              }}
            >
              Não
            </button>
          </Row>
        </div>
      </Popover>
    </Container>
  );
}

export default Trip;
